util = require("../util/util.coffee")

# Fetches data stored in the cookie.  Cookies are shared between www.themuse.com
# and partners.themuse.com by using .themuse.com as the domain.

# Contains a mapping of company_ids to an array of applied job_id's
# stored in a cookie to be used during our external tracking script
# {"company_id":[job_id1, job_id2], "company_id2": [job_id3], job_id4]}
# {"423":[1425, 23421, 3242, 9324], "120":[54153, 43152, 54131, 54342]}
JOB_APPLY_IDS_LIST_KEY = "external_job_ids_list"

EXTERNAL_JOB_ID_KEY = "external_job_id"

getStorage = () ->
    job_id_list_encoded = util.getCookie(JOB_APPLY_IDS_LIST_KEY)

    {
        external_job_ids_list: if job_id_list_encoded then JSON.parse(window.atob(job_id_list_encoded)) else {}
        external_job_id: util.getCookie(EXTERNAL_JOB_ID_KEY) or 0
    }

setExternalJobsList = (external_job_ids_list, cookie_domain) ->
    # Encode the storage object before putting it into cookies
    encoded = window.btoa(JSON.stringify(external_job_ids_list))
    # use themuse.com as domain for cookie so we can have a shared cookie (.themuse.com)
    util.setCookie(JOB_APPLY_IDS_LIST_KEY, encoded, 30, "/", cookie_domain)

setExternalJobId = (external_job_id, cookie_domain) ->
    # Store the external_job_id value unless it is null,
    # then unset the cookie
    if external_job_id
        util.setCookie(EXTERNAL_JOB_ID_KEY, external_job_id, 30, "/", cookie_domain)
    else
        util.deleteCookie(EXTERNAL_JOB_ID_KEY, "/", cookie_domain)

module.exports = {
    getStorage: getStorage
    setExternalJobsList: setExternalJobsList
    setExternalJobId: setExternalJobId
}



// WEBPACK FOOTER //
// ./node_modules/musecoreui/tracking/external_tracking.coffee